import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../redux/actions";
import { Link, useParams } from "react-router-dom";
import { Button } from "@chakra-ui/react";
import SpinnerLoading from "components/Loading/SpinnerLoading";
import currencyFormatter from '../../../util/functions/currencyFormat'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// import currencyFormatter from "currency-formatter";
import THBText from "thai-baht-text";
import _ from "lodash";
import moment from "moment";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
    THSarabunNew: {
        normal: "THSarabunNew.ttf",
        bold: "THSarabunNew Bold.ttf",
        italics: "THSarabunNew-Italic.ttf",
        bolditalics: "THSarabunNew-BoldItalic.ttf",
    },
    Roboto: {
        normal: "Roboto-Regular.ttf",
        bold: "Roboto-Medium.ttf",
        italics: "Roboto-Italic.ttf",
        bolditalics: "Roboto-MediumItalic.ttf",
    },
};

export default function ReportVehicle() {
    const [isLoading, setIsLoading] = useState(false);
    const { id } = useParams();
    const dispatch = useDispatch();
    const repair = useSelector((state) => state.repair);
    const company = useSelector((state) => state.company);
    const [repair_type, setRepairType] = useState([]);
    const [sumTotal, setSum] = useState(0);

    useEffect(() => {
        dispatch(actions.repairGetVehicle(id)).then(() => {
            dispatch(actions.companyAll())
        })
        return () => { }
    }, [])

    useEffect(() => {
        setRepairType(genRepairType());
        sumPrice();
        setIsLoading(true)
        return () => { }
    }, [repair, company])

    console.log("repair: ", repair);
    console.log("company", company);

    const sumPrice = () => {
        let sum = 0;
        for (let i = 0; i < _.size(repair?.problems); i++) {
            sum =
                parseInt(sum) + parseInt(repair?.problems[i].price);
            console.log("price", repair?.problems[i].price);
            console.log("sum", sum);
        }
        setSum(sum);
    }



    const printPDF = () => {
        var docDefinition = {
            pageSize: "A4",
            pageOrientation: "portrait",
            pageMargins: [40, 40, 40, 40],
            defaultStyle: {
                font: "THSarabunNew",
                fontSize: "16",
            },
            info: {
                title: "ใบแจ้งซ่อมรถ"
            },
            content: [
                {
                    alignment: "justify",
                    columns: [
                        {
                            image: "company_logo",
                            width: 60,
                            margin: [0, 10, 0, 10],
                        },
                        [
                            {
                                text: company.company_name,
                                fontSize: "18",
                                bold: true,
                            },

                            {
                                text: `${company.company_address} โทร: ${company.company_phone_number}`,
                                fontSize: "14",
                            },
                            {
                                text: "อีเมล : " + company.company_email,
                                fontSize: "14",
                            },
                        ],
                    ],
                },
                {
                    canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 }]
                },
                {
                    //หัวข้อ
                    alignment: "center",
                    margin: [0, 20, 0, 20],
                    text: "ใบแจ้งซ่อมรถ",
                    fontSize: "23",
                    bold: true,
                },
                {
                    alignment: "justify",
                    columns: [
                        [
                            {
                                text: `วัน-เดือน-ปี .......... ${moment(repair.createdAt).format("DD/MM/YYYY")} ...........`,
                                fontSize: "16",
                            },
                        ],
                        [
                            {
                                text: `ประเภทรถ .......... ${repair?.vehicle?.sub_category_vehicle.sub_category_name} ............`,
                                fontSize: "16",
                                alignment: "center",
                            },
                        ],
                        [
                            {
                                text: `เลขไมล์ ............ ${repair?.mileage.mileage} ............ `,
                                fontSize: "16",
                                alignment: "center",
                            }
                        ]
                    ]
                },
                {
                    alignment: "justify",
                    columns: [
                        [
                            {
                                text: `ทะเบียนหัว .......... ${repair?.vehicle?.serial_number} ...........`,
                                fontSize: "16",
                            },
                        ],
                        [
                            {
                                text: `ทะเบียนหาง .......... ${repair?.vehicle_tail?.serial_number} ............`,
                                fontSize: "16",
                                alignment: "center",
                            },
                        ],
                        [
                            {
                                text: `ชื่อคนขับ ....... ${repair?.employee.employee_first_name} ${repair?.employee.employee_last_name} ...... `,
                                fontSize: "16",
                                alignment: "center",
                            }
                        ]
                    ]
                },
                {
                    margin: [0, 20, 0, 20],
                    style: "tableExample",
                    layout: {
                        fillColor: function (rowIndex, node, columnIndex) {
                            return rowIndex === 0 ? "#c2dec2" : null;
                        },
                    },
                    table: {
                        widths: ["*", "70%", "*"],
                        heights: [10, 10, 10, 10, 30, 10, 25],
                        headerRows: 1,
                        body: [
                            [
                                {
                                    text: "ลำดับ",
                                    colSpan: 1,
                                    fontSize: 14,
                                    alignment: "center",
                                },
                                {
                                    text: "ประเภทการซ่อม",
                                    colSpan: 1,
                                    fontSize: 14,
                                },
                                {
                                    text: "ราคา",
                                    colSpan: 1,
                                    fontSize: 14,
                                    alignment: "center",
                                }
                            ],
                            ...repair_type,
                            [
                                {
                                },
                                {
                                    text: `ราคาทั้งหมด`,
                                    colSpan: 1,
                                    fontSize: 14,
                                },
                                {
                                    text: `${sumTotal}`,
                                    colSpan: 1,
                                    fontSize: 14,
                                    alignment: "center",
                                },
                            ],
                        ],
                    },
                },
                {
                    margin: [0, 20, 0, 20],
                    fontSize: 14,
                    columns: [
                        [
                            {
                                text: `หมายเหตุ :  ..............................................................................................................................................................................................................`,
                            },
                            {
                                text: `..................................................................................................................................................................................................................................`,
                            },
                            {
                                text: `..................................................................................................................................................................................................................................`,
                            },
                            {
                                text: `..................................................................................................................................................................................................................................`,
                            }
                        ]
                    ]
                },
                {
                    alignment: "justify",
                    margin: [0, 100, 0, 100],
                    columns: [
                        [
                            {
                                text: `ลงชื่อ ..........................................ผู้แจ้ง`,
                                fontSize: "16",
                                alignment: "center",
                            },
                            {
                                text: `(.......................................................)`,
                                fontSize: "16",
                                alignment: "center",
                            },
                        ],
                        [
                            {
                                text: `ลงชื่อ ..........................................ผู้อนุมัติ`,
                                fontSize: "16",
                                alignment: "center",
                            },
                            {
                                text: `(.......................................................)`,
                                fontSize: "16",
                                alignment: "center",
                            },
                        ],
                    ],
                },
            ],
            images: {
                company_logo: company.company_logo,
            },
        };
        pdfMake.createPdf(docDefinition).open();
    };

    const genRepairType = () => {
        return _.map(repair?.problems, (_problems, index) => [
            {
                text: index + 1,
                border: [true, false, true, false],
                colSpan: 1,
                alignment: "center",
            },
            {
                text: _problems?.repair_type.repair_detail,
                border: [true, false, true, false],
                colSpan: 1,
            },
            {
                text: _problems.price,
                border: [true, false, true, false],
                colSpan: 1,
                alignment: "center",
            }
        ])
    }

    console.log("Sum Total", sumTotal);

    return isLoading ? (
        <div>
            {/* { printPDF()} */}
            <h2 className="text-gray-800 text-xl font-semibold">
                รายละเอียดใบแจ้งซ่อมรถ
            </h2>
            <div className="py-4">
                <Button
                    colorScheme="blue"
                    onClick={() => {
                        printPDF();
                    }}
                >
                    พิมพ์
                </Button>
            </div>
        </div>
    ) : (
        <SpinnerLoading />
    )
}
